//@flow

import React from "react";

import { ContinueLink } from "@/components";

export type BulletPointProps = {
    title: string,
    content?: string,
    link?: Link,
};

const BulletPoint = ({title, content, link}: BulletPointProps): React$Element<React$FragmentType> => (
    <>
        <h2 className="h3 plus-prefix mb-3">{title}</h2>
        {content ? <div className="text-muted">{content}</div> : <></>}
        {link ? (
            <ContinueLink styles={"mt-3"} to={link.path} variant={"dark"}>
                {link.text}
            </ContinueLink>
        ) : (
            <></>
        )}
    </>
);

export default BulletPoint;
